export default __webpack_public_path__ + "static/media/Skirmisher's Blade.dc935329.jpg";